import { alias, params, client } from '@thd-nucleus/data-sources';
import {
  arrayOf as arrayOfType,
  bool as boolType, number as numberType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';

export const dataModel = {
  clientOnlyProduct: alias('product').params({
    itemId: stringType().isRequired()
  }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      productLabel: stringType(),
      parentId: stringType(),
    }),
    info: shapeType({
      hasSubscription: boolType(),
      minimumOrderQuantity: numberType(),
      projectCalculatorEligible: boolType(),
      productDepartment: stringType(),
      classNumber: stringType(),
      subClassNumber: stringType(),
      calculatorType: stringType(),
      pipCalculator: shapeType({
        coverageUnits: stringType(),
        display: boolType(),
        publisher: numberType(),
        toggle: stringType()
      })
    }),
    pricing: params({ storeId: stringType() }).shape({
      alternatePriceDisplay: boolType(),
      unitOfMeasure: stringType(),
      alternate: shapeType({
        bulk: shapeType({
          thresholdQuantity: numberType({ float: true }),
          value: numberType({ float: true })
        }),
        unit: {
          caseUnitOfMeasure: stringType(),
          unitsPerCase: numberType({ float: true }),
          value: numberType({ float: true }),
        }
      }),
      original: numberType({ float: true }),
      value: numberType({ float: true })
    }),
    availabilityType: shapeType({
      discontinued: boolType(),
      status: boolType(),
      buyable: boolType(),
      type: stringType()
    }),
    fulfillment: client(params({ storeId: stringType(), zipCode: stringType(), quantity: numberType() }).shape({
      fulfillmentOptions: arrayOfType(shapeType({
        type: stringType(),
        fulfillable: boolType(),
        services: arrayOfType(shapeType({
          locations: arrayOfType(shapeType({
            inventory: shapeType({
              quantity: numberType()
            }),
            isAnchor: boolType(),
            locationId: stringType(),
            storeName: stringType(),
            type: stringType()
          })),
          type: stringType(),
          optimalFulfillment: boolType(),
        }))
      }))
    })),
    installServices: params({ storeId: stringType(), zipCode: stringType() }).shape({
      scheduleAMeasure: boolType()
    }),

    specificationGroup: arrayOfType(shapeType({
      specTitle: stringType(),
      specifications: arrayOfType(shapeType({
        specName: stringType(),
        specValue: stringType()
      }))
    }))
  })
};
